import { CSSProperties } from '@mui/styles';

export const DISABLED_OPACITY = 0.5;

export const disabled: CSSProperties = {
  opacity: DISABLED_OPACITY,
  pointerEvents: 'none',
};
